import { render, staticRenderFns } from "./v-hero-slider.vue?vue&type=template&id=564b9da5&scoped=true&"
import script from "./v-hero-slider.vue?vue&type=script&lang=js&"
export * from "./v-hero-slider.vue?vue&type=script&lang=js&"
import style0 from "./v-hero-slider.vue?vue&type=style&index=0&id=564b9da5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b9da5",
  null
  
)

export default component.exports